import {
  FiCrop,
  FiRotateCcw,
  FiRotateCw,
  FiZoomIn,
  FiZoomOut
} from "react-icons/fi";

import { useContext } from "react";
import { useTranslator } from "@eo-locale/react";

import { ButtonGroup, IconButton } from "@/storybook-components";
import { CropperContext, CropperContextType } from "../context";

function Controls() {
  const { translate } = useTranslator();
  const { cropperRef, status, isCropActive, setIsCropActive } = useContext(
    CropperContext
  ) as CropperContextType;

  const startCrop = () => cropperRef.current?.cropper.crop();
  const clearCrop = () => cropperRef.current?.cropper.clear();

  return (
    <ButtonGroup
      size="lg"
      width="full"
      display="flex"
      variant="tertiary"
      justifyContent="space-between"
      isDisabled={status === "disabled"}
    >
      <IconButton
        isRound
        icon={<FiCrop />}
        isActive={isCropActive}
        aria-label={translate("common.crop")}
        onClick={() => {
          if (isCropActive) clearCrop();
          else startCrop();

          setIsCropActive(!isCropActive);
        }}
      />
      <IconButton
        isRound
        icon={<FiZoomIn />}
        aria-label={translate("common.zoomIn")}
        onClick={() => cropperRef.current?.cropper.zoom(0.1)}
      />
      <IconButton
        isRound
        icon={<FiZoomOut />}
        aria-label={translate("common.zoomOut")}
        onClick={() => cropperRef.current?.cropper.zoom(-0.1)}
      />
      <IconButton
        isRound
        icon={<FiRotateCcw />}
        aria-label={translate("common.rotateLeft")}
        onClick={() => cropperRef.current?.cropper.rotate(-90)}
      />
      <IconButton
        isRound
        icon={<FiRotateCw />}
        aria-label={translate("common.rotateRight")}
        onClick={() => cropperRef.current?.cropper.rotate(90)}
      />
    </ButtonGroup>
  );
}

export { Controls };
